import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import useCustomerInitiativeCreate from './CustomerInitiativeCreate.hook';
import CustomerInitiativeForm from 'modules/maya/components/CustomerInitiativeForm/CustomerInitiativeForm';
import Heading from 'modules/maya/components/Heading';
import MayaLayout from 'modules/maya/components/MayaLayout';
import Box from 'yoda-ui/Box';
import Loader from 'yoda-ui/Loader';

const CustomerInitiativeCreate: FC = () => {
  const { t } = useTranslation();
  const {
    loading,
    parentStrategicImperative,
    handleSaveCustomerInitiativeForm,
    handleCancelCustomerInitiativeForm,
  } = useCustomerInitiativeCreate();

  return (
    <MayaLayout>
      <Heading>
        { t('maya_customer_initiative_form_title') }
      </Heading>

      {
        loading
          ? (

            <Box display="flex" flexDirection="column" justifyContent="center" height="100%">
              <Loader center />
            </Box>
          )
          : (
            <CustomerInitiativeForm {
              ...{
                parentStrategicImperative,
                submitCallback: handleSaveCustomerInitiativeForm,
                cancelCallback: handleCancelCustomerInitiativeForm,
              }
            } />
          )
      }
    </MayaLayout>
  );
};

export default CustomerInitiativeCreate;
